<template>
  <v-dialog v-model="dialogComputed" max-width="2000px" scrollable :persistent="!disabled">
    <v-card>
      <v-card-title class="primary white--text py-2">
        {{ $t('ELE0383') }}
        <v-spacer />
        <Btn icon="mdi-close" @click="close" depressed iconProp color="white" />
      </v-card-title>
      <v-card-text class="pb-0 mt-1">
        <v-data-table
          :headers="headersComputed"
          :items="items"
          fixed-header
          disable-pagination
          hide-default-footer
          dense
        >
          <template v-slot:[`item.isSelected`]="{ item }">
            <v-simple-checkbox label="" v-model="item.isSelected" :ripple="false" color="primary" />
          </template>
          <template v-slot:[`item.saNo`]="{ item }">
            <BtnLink :label="item.saNo" @click="onClickSaNo(item.saNo)" />
          </template>
          <template v-slot:[`item.saRule`]="{ item }">
            {{ $t(`SaRuleCd.${item.saRule}`) }}
          </template>
          <template v-slot:[`item.requestDatetme`]="{ item }">
            {{ toLocalTime(item.requestDatetme) }}
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <span class="d-flex flex-row space-between">
          <Btn v-if="!disabled" :label="$t('ELE0105')" @click="onClickSet" />
        </span>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import DateUtils from '@/mixin/date-utils.js'
import cloneDeep from 'lodash/cloneDeep'

import Btn from '@/components/atoms/base/button/Btn'
import BtnLink from '@/components/atoms/base/button/BtnLink'

export default {
  name: 'SelectSaDialog',

  mixins: [APIUtils, Message, DateUtils],

  components: {
    Btn,
    BtnLink,
  },

  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    propsItems: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      items: [],
    }
  },

  computed: {
    dialogComputed: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      },
    },
    headersComputed: {
      get() {
        let headers = []
        if (!this.disabled) {
          headers.push({ text: '', value: 'isSelected', divider: true, sortable: false })
        }
        headers.push({ text: this.$t('ELE0184'), value: 'saNo', divider: true, sortable: false })
        headers.push({ text: this.$t('ELE0381'), value: 'saRule', divider: true, sortable: false })
        headers.push({ text: this.$t('ELE0387'), value: 'requestDatetme', divider: true, sortable: false })
        headers.push({ text: this.$t('ELE0382'), value: 'saQty', divider: true, sortable: false, align: 'end' })
        headers.push({ text: this.$t('ELE0384'), value: 'totalInspQty', divider: true, sortable: false, align: 'end' })
        headers.push({ text: this.$t('ELE0049'), value: 'lotNo', divider: false, sortable: false })
        return headers
      },
    },
  },

  watch: {
    dialog() {
      if (this.dialog) {
        this.init()
      }
    },
  },

  methods: {
    init() {
      this.items = cloneDeep(this.propsItems)
    },
    async close() {
      this.dialogComputed = false
      this.$emit('close')
    },
    async onClickSet() {
      this.$emit('set', this.items)
      this.dialogComputed = false
    },
    onClickSaNo(saNo) {
      const resolvedRoute = this.$router.resolve({
        name: 'T07',
        query: { saNo: saNo },
      })
      window.open(resolvedRoute.href, '_blank')
    },
  },
  mounted() {
    this.init()
  },
}
</script>
